import { useState } from "react";
import useCancelableReq from "./useCancelableReq";
/**
 * @description Hook to prepare cancelable image request.
 * `fn` must return a Request with Blob response
 */
export default function useCancelableImg(fn, opts) {
    var _a = opts || {}, _b = _a.isLazy, isLazy = _b === void 0 ? false : _b, _c = _a.cancelOnUnmount, cancelOnUnmount = _c === void 0 ? true : _c, controller = _a.controller, onComplete = _a.onComplete, onFail = _a.onFail, onCancel = _a.onCancel;
    var _d = useCancelableReq(fn, {
        controller: controller,
        cancelOnUnmount: cancelOnUnmount,
        isLazy: isLazy,
        onComplete: handleComplete,
        onFail: onFail,
        onCancel: onCancel
    }), isLoading = _d.isLoading, error = _d.error, cancel = _d.cancel, makeLazyRequest = _d.makeLazyRequest;
    var _e = useState(), src = _e[0], setSrc = _e[1];
    function handleComplete(blob) {
        if (!(blob instanceof Blob)) {
            throw Error('[react-cancelable] useCancelableImg: Request must return Blob');
        }
        var imageObjectURL = URL.createObjectURL(blob);
        setSrc(imageObjectURL);
        onComplete === null || onComplete === void 0 ? void 0 : onComplete(imageObjectURL);
    }
    return {
        src: src,
        error: error,
        isLoading: isLoading,
        cancel: cancel,
        makeLazyRequest: makeLazyRequest
    };
}
